















import {Component, Prop, Vue} from 'vue-property-decorator';
import SuccessIcon from '@/components/Icons/SuccessIcon.vue';
import InfoIcon from '@/components/Icons/InfoIcon.vue';
import ErrorIcon from '@/components/Icons/ErrorIcon.vue';

@Component({
  components: {ErrorIcon, InfoIcon, SuccessIcon},
})
export default class DialogConfirmIcon extends Vue {
  @Prop() color!: string;
  @Prop() icon!: string;
  @Prop() center!: string;
}
